
import TNTBillingBase from "../../util/TNTBillingBase";

class ContractTypeController extends TNTBillingBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.$state = $state;
        this.id = "contract_type";
        this.acl = {};
        this.hasACL = {};
    }
    
    $onInit() {
        super.$onInit()
        for (let key in this.acl['tnt_billing_' + this.id]) {
            this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
        }
        
    }
}

export default ContractTypeController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/contract_type.controller.js